import TagManager from "react-gtm-module";

const ShareItemGA = {
  shareOpenModal: itemType => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "share",
        event_action: `${itemType}`,
        event_label: "open"
      }
    });
  },
  shareCloseModal: itemType => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "share",
        event_action: `${itemType}`,
        event_label: "close"
      }
    });
  },
  shareSubmitForm: (itemType, itemId) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "share",
        event_action: `${itemType}`,
        event_label: `${itemId}`
      }
    });
  },
  shareSubmitFormExclusiveMarketing: sstValue => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "share",
        event_action: "sale",
        event_label: `sst=${sstValue}`
      }
    });
  }
};

export default ShareItemGA;
